import { ref, uploadBytes } from "firebase/storage";
import { storage } from "./firebase";
import { api } from "./api";

const MAX_BYTES = 10 * 1024 * 1024;

export type UploadResult = Awaited<ReturnType<typeof api.createPurchase>>["data"];

export async function uploadAndCreatePurchase(opts: {
  tenantId: string;
  uid: string;
  file: File;
  discountCode?: string;
}): Promise<UploadResult> {
  if (opts.file.size > MAX_BYTES) {
    throw new Error("La imagen pesa más de 10 MB. Reduce el tamaño y vuelve a intentar.");
  }
  const ext = guessExt(opts.file.type) || "jpg";
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `tenants/${opts.tenantId}/purchases/${opts.uid}/${id}.${ext}`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, opts.file, { contentType: opts.file.type });
  const result = await api.createPurchase({
    storagePath: path,
    discountCode: opts.discountCode
  });
  return result.data;
}

function guessExt(mime: string): string | null {
  if (mime === "image/jpeg") return "jpg";
  if (mime === "image/png") return "png";
  if (mime === "image/webp") return "webp";
  if (mime === "image/heic" || mime === "image/heif") return "heic";
  return null;
}
